import { OverlayTrigger, Popover } from "react-bootstrap";

import { getKeyStatusValuesByStatus } from "../../_constants/keys";
import KeyIcon from "../../assets/svg/keyData";
import { IService } from "../../modules/serviceOrdering/reducers";

type KeyDataGridComponentProps = {
  service: IService;
};

const KeyDataGridComponent = ({ service }: KeyDataGridComponentProps) => {
  return (
    <div>
      {service?.dwelling?.key?.lastStatus ? (
        <OverlayTrigger
          trigger={["hover", "focus"]}
          placement={"bottom"}
          overlay={
            <Popover id={`actionsComponentLink`}>
              <Popover.Body className="p-0 m-2 popoverTextSecondary">
                <strong>
                  {getKeyStatusValuesByStatus(
                    service?.dwelling?.key?.lastStatus?.status?.status,
                  ).hint || ""}
                </strong>
              </Popover.Body>
            </Popover>
          }
        >
          <div className="mx-2" style={{ cursor: "pointer" }}>
            <KeyIcon
              color={
                getKeyStatusValuesByStatus(
                  service?.dwelling?.key?.lastStatus?.status?.status,
                ).color || "#000"
              }
            />
          </div>
        </OverlayTrigger>
      ) : (
        <div className="mx-2" style={{ cursor: "pointer" }}>
          <KeyIcon color={"#777"} />
        </div>
      )}
    </div>
  );
};
export default KeyDataGridComponent;
